<template>
  <main-layout
    :tabs="tabs"
    :tab-id="currentTabId"
    class="insurance"
    custom-back
    @changeTab="changeTab"
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <component :is="tabPage" ref="typeList"></component>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import InsuranceList from "@/views/ruralInsurance/InsuranceList/Index.vue";
import OrderList from "@/views/ruralInsurance/OrderList/Index.vue";
// import { windowHref } from "@/utils/index";
import {
  getStorage,
  setStorage,
  removeStorage,
  SessionStorage,
} from "@/utils/storage";

export default {
  name: "ruralInsurance",

  components: {
    MainLayout,
    InsuranceList,
    OrderList,
  },
  data() {
    return {
      currentTabId: 0,
      tabs: [
        {
          id: 0,
          name: "保险保单",
        },
        {
          id: 1,
          name: `投保意向单`,
        },
      ],
    };
  },
  created() {
    if (getStorage("pathWhere") === "/insuranceList") {
      setStorage("indexType", { id: 0, name: "保险保单" });
      this.currentTabId = 0;
    } else {
      if (this.$route.params.id) {
        // this.currentTabId = this.$route.params.id;
        this.currentTabId = 1;
      } else {
        this.currentTabId = getStorage("indexType").id;
      }
    }
    if (this.currentTabId == 0) {
      SessionStorage.remove("ruralSeleorderStatus");
    }
  },

  computed: {
    tabPage() {
      // 有数据
      return this.currentTabId == 0 ? "InsuranceList" : "OrderList";
    },
  },
  methods: {
    goBack() {
      // window.history.go(-1);
      this.$router.push({
        name: "InsuranceList",
        params: {
          id: 1,
        },
      });
      // 回到主页
      // windowHref("/home/home");
    },
    changeTab(tab) {
      setStorage("indexType", tab);
      this.currentTabId = tab.id;
    },
  },
  beforeDestroy() {
    removeStorage("pathWhere");
  },
};

/**
 *
 * 存类型  insurance  indexType  0 保单 1 订单
 * indexType 0 保单列表 1 订单列表
 *
 * detailsType 1 保单详情 2 订单详情 3 保险介绍
 */
</script>

<style lang="scss" scoped>
.insurance {
  .main-content {
    width: 1290px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
  }
}
::v-deep .el-table {
  border: 0;
  th,
  tr,
  td {
    border: 0;
  }
  &::before {
    height: 0px;
  }
}

::v-deep .tab-item {
  font-size: 22px !important;
}

// 表格行样式
::v-deep .statistics-warning-row {
  background: $--color-tablist;
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}
::v-deep .bscroll-vertical-scrollbar {
  z-index: 1 !important;
}

//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 80px;
}
// 行背景色
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff !important;
}

::v-deep .el-table__row {
  height: 62px;
}
::v-deep .el-table td,
.el-table th.is-leaf {
  border: none;
}
// 表格最外边框
.el-table--border,
.el-table--group {
  border: none;
}
// 加载圈
::v-deep .el-loading-mask {
  z-index: 1;
}
</style>
